module.exports = __webpack_public_path__ + "img/VALLONE_FINISH_WOOD_LEGNO_ROVERE_VINTAGE .5d93b9a0.jpg";